import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { useHistory } from "react-router-dom";
import { AddTicketThreadService, CloseTicketService, GetSingleTicketsService, readTicketIndicator } from "../../services/TicketService";
import { BASE_URL, UPLOAD_ROOT_PATH } from "../../utils/Constants";
import { TrimText } from "../common/TrimText";
import {
  getCurrentTimeHomePage,
  InitalRender
} from "./../common/Helper";
import TicketComments from "./NewTicketComments";
import StatusRender, { CategoryRender, DepartmentRender } from "./StatusRender";
import { ContainerWrapper } from "../common/GlobalElements/Wrappers";
import { StandardButton } from "../common/GlobalElements/StandardButton";
import { Heading3, TextLink } from "../common/GlobalElements/Typography";
import PageHeader from "../common/GlobalElements/PageHeader";
import Swal from "sweetalert2";
import { tokens } from "../../public/tokens";

export default function NewTicketView(props) {
  const { selectedTicket, setSelectedTicket } = props;
  const [ticket, setTicket] = useState([]);
  const [ticketThread, setTicketThread] = useState([]);
  const [ticketCategory, setTicketCategory] = useState("");
  const [ticketDepartment, setTicketDepartment] = useState("");
  const [isLoading, setIsLoading] = useState(false); 
  const history = useHistory();
  const [copyText, setCopyText] = useState(0);

  useEffect(() => {
    let componentMounted = true
    GetSingleTicketsService(selectedTicket)
      .then((res) => {
        if (componentMounted) {
          setTicket(res.data.ticket);
          setTicketDepartment(res.data.ticket.department);
          setTicketCategory(res.data.ticket.category);
          if (res.data.threadList) setTicketThread(res.data.threadList);
          else setTicketThread({});
        }
        readTicketIndicator({ 'id_ticket': res.data.ticket.id_ticket }).then((res) => {
        });
      })
      .catch((error) => {
        console.error(error);
      });

    return function cleanup() {
      componentMounted = false
    }
  }, [selectedTicket]);

  const handleTicketThread = async (value) => {
    try {
      const res = await AddTicketThreadService(value);
      let updatedChat = res.data[0];
      setTicketThread((ticketThread) => [...ticketThread, updatedChat]);
      // Update ticket status from response
      setTicket((prevTicket) => ({ ...prevTicket, status: res.data[0].status }));
    } catch (error) {
      console.error("Failed to add comment:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to add comment. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleCloseTicket = async () => {
    if (!ticket?.id_ticket || isLoading) return;

    // Confirmation Modal
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once closed, you will not be able to edit or respond to this ticket.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, close the ticket",
      cancelButtonText: "Cancel",
      confirmButtonColor: tokens.colors.brand.blue[500],
      cancelButtonColor: tokens.colors.brand.red[500],
    });

    if (!result.isConfirmed) return;

    // User confirmed - proceed with closing
    setIsLoading(true);

    try {
      await CloseTicketService(selectedTicket);
      
      // Update ticket status
      setTicket((prevTicket) => ({ ...prevTicket, status: 'Closed' }));

      // Success Modal
      await Swal.fire({
        icon: "success",
        title: "Success!",
        text: "This ticket has been closed. Please log a new ticket if you need further assistance.",
        confirmButtonText: "OK",
        confirmButtonColor: tokens.colors.brand.blue[500],
      });
    } catch (error) {
      console.error("Failed to close ticket:", error);
      await Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to close ticket. Please try again.",
        confirmButtonText: "OK",
        confirmButtonColor: tokens.colors.brand.blue[500],
      });
    } finally {
      setIsLoading(false);
    }
  }

  const handleOpenForm = (value) => {
    history.push('/mytickets');
    props.setOpenForm(value);
    props.setSelectedTicket(undefined);
  }

  const copyEmailText = (email) => {
    setCopyText(1);
    navigator.clipboard.writeText(email);
    setTimeout(() => {
      setCopyText(0)
    }, 1000);
  }

  return (
    <>
      {ticket ? (
        <div className="Tickets-right-main">
          <div className="Tickets-detail">
            <div className="Tickets-detail-head d-flex align-items-center mb-0">
              <PageHeader>
                <div className="name-w-head d-flex align-items-center ">
                  <Heading3 className="landing-heading">
                    Tickets <span>Details</span>
                  </Heading3>
                  <div className="Tickets-head-rgt-new ticket-status-blk">
                    <Heading3 className="mb-1">{TrimText(ticket.subject)}</Heading3>
                    {ticket.status ? <StatusRender status={ticket.status} /> : null}
                  </div>
                </div>
                <div className="text-md-right action2-blk">
                  <div className="ticket-view-btn d-flex align-items-center">
                    {ticket.status != "Closed" && ticket.status != undefined && (
                      <StandardButton
                        className="add-new-ticket-bx"
                        onClick={() => handleCloseTicket()}
                        title="Close Ticket"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="fas fa-cog fa-spin"></i>
                        ) : (
                          <i className="fal fa-times"></i>
                        )}
                        Close Ticket
                      </StandardButton>
                    )}

                    <StandardButton
                      variant="white"
                      outline={true}
                      className="add-new-ticket-bx ml-3"
                      title="Back"
                      onClick={() => {
                        setSelectedTicket();
                        history.push("/mytickets")
                      }}
                    >
                      <i className="fal fa-angle-left"></i>Back
                    </StandardButton>

                  </div>
                </div>
              </PageHeader>
              <div className="text-md-right ml-auto">
                <p className="">
                  {" "}
                  {getCurrentTimeHomePage(Date().toLocaleString())}{" "}
                </p>
              </div>
            </div>
            <div className="Tickets-detail-body row">
              <div className="ticket-details col-md-3">
                <ContainerWrapper className="ac-white-card p-0">
                  <div className="p-4">
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-6">
                        <h2 className="ticket-id">#{ticket.id_ticket}</h2>
                      </div>
                      <div className="col-md-6">
                        <label className="lb-black">
                          <b>Assigned To</b>
                        </label>
                        <div className="assigned-title-blk assigned-title-right">
                          <div className="assigned-title-itm">
                            <span className="name-icon">
                              {ticket.assign_to_photo ? <img src={BASE_URL + "/" + ticket.assign_to_photo.replace(`${UPLOAD_ROOT_PATH}/`, "")} onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.closest('.name-icon').append(InitalRender(ticket.assign_to ? ticket.assign_to : 'NA'));
                                currentTarget.remove();
                              }} /> : (ticket.assign_to ? InitalRender(ticket.assign_to) : 'NA')}
                              {ticket?.assign_to_status == "Offline" ? <span className="portal-status-icon offline-u"></span> : <span className="portal-status-icon online-u"></span>}
                            </span>
                            {TrimText(ticket.assign_to ? ticket.assign_to : 'NA', 20)}
                          </div>
                          <div className="assigned-title-info online_newpoints01">
                            <article>
                              <figure>{ticket.assign_to_photo ? <img src={BASE_URL + "/" + ticket.assign_to_photo.replace(`${UPLOAD_ROOT_PATH}/`, "")} onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.closest('figure').append(InitalRender(ticket.assign_to ? ticket.assign_to : 'NA'));
                                currentTarget.remove();
                              }} /> : InitalRender(ticket.assign_to ? ticket.assign_to : 'NA')}
                                 {ticket?.assign_to_status == "Offline" ? <span className="portal-status-icon offline-u"></span> : <span className="portal-status-icon online-u"></span>}
                              </figure>
                              <figcaption>
                                <h4>{TrimText(ticket.assign_to ? ticket.assign_to : 'NA', 20)}</h4>
                                <p>
                                  <i className="fal fa-envelope"></i>
                                  {ticket.assign_to_email ?
                                    <>
                                      <a className="hover-color-blue" onClick={() => copyEmailText(ticket.assign_to_email)}>
                                        {TrimText(ticket.assign_to_email ? ticket.assign_to_email : "NA", 20)}
                                      </a>
                                      {copyText ? (
                                        <i className="fas fa-check-circle cat-greenhex"></i>
                                      ) : (
                                        ticket.assign_to_email && <i
                                          className="fal fa-copy hover-color-blue"
                                          onClick={() => copyEmailText(ticket.assign_to_email)}
                                        ></i>
                                      )}</> : "N/A"}

                                </p>
                              </figcaption>
                            </article>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="lb-black">
                          <b>Date Modified</b>
                        </label>
                        <p>
                          {moment(ticket.last_update).format(
                            "D MMM YYYY HH:mm"
                          )}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <label className="lb-black">
                          <b>Date Created</b>
                        </label>
                        <p>
                          {moment(ticket.date_add).format("D MMM YYYY HH:mm")}
                        </p>
                      </div>

                      <div className="col-md-6">
                        <label className="lb-black">
                          <b>Department</b>
                        </label>
                        <p>{ticket.department ? <DepartmentRender status={ticket.department} /> : ""}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="lb-black">
                          <b>Category</b>
                        </label>
                        <CategoryRender status={ticket.category} />
                      </div>

                      {ticket &&
                        ticket.attachments &&
                        ticket.attachments.length > 0 && (
                          <div className="col-md-12">
                            <label className="lb-black">
                              <b>Attachments</b>
                            </label>
                            <div className="doc-list">
                              {ticket.attachments.map((i, index) => (
                                <div className="doc-list-in d-flex relative-class mb-2" key={`attachment-${index}`}>
                                  <div className="icon-w-box">
                                    <i className="fal fa-paperclip"></i>
                                  </div>
                                  <div className="doc-list-info">
                                    <TextLink
                                      target="_blank"
                                      href={i.attachment}
                                      download
                                      rel="noopener noreferrer"
                                    >
                                      {i.originalName}
                                    </TextLink>
                                    <span className=" attch-text-font">
                                      {i.extentsion}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="description p-4">
                    <label className="lb-black d-block">
                      <b>Message</b>
                    </label>
                    <p>{ticket.campus_name ? `Campus: ${ticket.campus_name}` : ""}</p>
                    {ticket.message ? ReactHtmlParser(ticket.message) : ""}
                  </div>
                </ContainerWrapper>
              </div>
              <TicketComments
                ticketData={ticket}
                ticketThread={ticketThread}
                id_ticket={ticket.id_ticket}
                parentHandleTicketThread={handleTicketThread}
                scroll_down_bottom_parent={props.scroll_down_bottom_parent}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
